module.exports = __webpack_public_path__ + "static/media/AkkuratLight.7b411e00.woff";